import gql from 'graphql-tag'
export const GET_BRAND_NAVIGATION = gql`
  query GetBrandNavigation {
    brandNavigation {
      allBrandsUrl
      brands {
        logo {
          height
          url
          relativeUrl
        }
        name
        url
      }
    }
  }
`
